export const GqlClientName = {
  Hygraph: 'hygraph',
  Jobs: 'jobs',
  MyOmr: 'myomr',
  Reviews: 'reviews',
  Shopify: 'shopify',
} as const

export type GqlClientName = (typeof GqlClientName)[keyof typeof GqlClientName]
